<script setup lang="ts">
import { useApiStore } from "@/stores/api/useApiStore";
import { HaskoningSwitch, HaskoningText } from "@haskoning/vue-component-library";
import { storeToRefs } from "pinia";

const apiStore = useApiStore();
const { autoGenerateForm } = storeToRefs(apiStore);
</script>

<template>
  <div class="d-flex align-center justify-space-between ga-3 text-onSurface" style="min-width: 100px">
    <HaskoningText as="p" variant="body-large" color="onBackground" truncate> Enable auto generate form </HaskoningText>
    <HaskoningSwitch v-model="autoGenerateForm" class="flex-0-0" :icon="false" :disabled="false" />
  </div>
</template>
